import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-paper flex flex-col items-center justify-center text-center px-4">
      <div className="relative">
        <h1 className="font-serif text-[8rem] md:text-[12rem] leading-none text-lilac/20 select-none pointer-events-none">
          404
        </h1>
      </div>
      <div className="relative z-10 -mt-8 md:-mt-12">
        <h2 className="font-serif text-[1.5rem] md:text-[2.125rem] text-ink mb-4">
          這個頁面正在宇宙旅途中
        </h2>
        <p className="text-[1.1875rem] text-ink-2 mb-2">{location.pathname}</p>
        <p className="text-[1.1875rem] text-ink-2 mb-8">
          告訴我這個頁面的內容，我來為你生成！
        </p>
        <Link to="/" className="btn-primary">
          回到首頁
        </Link>
      </div>
    </div>
  );
}